<template>
  <div class="contenedor-reproductor">
    <div class="reproductor">
      <div class="controles">
        <button class="btn play" @click="toggle_play">
          <!--{{reproductor_is_play ? 'pausa' : 'play' }} -->
          <img v-if="!reproductor_is_play" src="@/assets/img/play.svg" alt="">
                <img v-if="reproductor_is_play" src="@/assets/img/pause.svg" alt="">
        </button>
      </div>
      <div class="historico">
        <output for="slider-reproductor"
        class="tooltip-reproductor"
        :style="{ left :`calc(${(valor_actual/(dias.length-1))*100}% + ${((valor_actual/(dias.length-1)*2)-1)*-11}px`}"
        >
          <span>{{diaActualTooltip}}</span>
        </output>
        <input class="slider-reproductor"
        type="range"
        min="0"
        :max="dias.length - 1"
        step="1"
        @change="cambioSlider"
        v-model="valor_actual"
        >
        <div class="fecha">
          <div class="item first-date">{{primerDia}}</div>
          <div class="item last-date">{{ultimoDia}}</div>
        </div>
      </div>
    </div>
    <p class="nota">El mapa presenta el acumulado de muestras hasta el marcador de la fecha</p>
  </div>
</template>

<script>
// import Play from "@/assets/img/play.svg"
import Timer from "./Timer.js"

export default {
  data() {
    return {
      current_frame:0,
      timer:undefined,
      timer_play : false,
      periodo_dias_frame:14
    };
  },
  components: {
    // Svg Componentes
    // Play,
  },
  mounted: function(){
    //this.valor_actual = dias.length
    this.timer = new Timer({
      delay: 600,
      steps: Math.ceil((this.dias.length-1)/this.periodo_dias_frame)+1,callback_step:(step)=>{
        //console.log("el animador va aqui...",step)
        this.valor_actual = (step * this.periodo_dias_frame) >= this.dias.length ? this.dias.length - 1 : step * this.periodo_dias_frame
      },
      first_step:Math.ceil((this.dias.length-1)/this.periodo_dias_frame),
      repeat:false
    })
    this.timer.onAutoStop= ()=>{
      //console.log("aqui llamando el callback")
      this.reproductor_is_play =false
    }
    //console.log(this.timer)
  },
  computed:{
    dias: function(){
      return Object.keys(this.$store.state.mapa.conteosPorfecha)
    },
    primerDia : function(){
      return generateDateFormat(this.dias[0])
    },
    ultimoDia : function(){
      return generateDateFormat( this.dias[this.dias.length-1])
    },
    diaActualTooltip: function(){
      return generateDateFormat(this.dias[this.valor_actual])
    },
    valor_actual:{
      get(){
        return this.$store.state.mapa.reproductorDiaActual
      },

      set(value){

        this.$store.commit("cambiarMapaReproductorDiaActual", {
          value:parseInt( value),
          refreshConteos:true
          })
      }
    },
    reproductor_is_play:{
      get(){
        return this.$store.state.mapa.reproductorPlay
      },
      set(value){
        this.$store.commit("cambiarMapaReproductorPlay",value)
      }
    }
  },
  watch:{
    dias:function(newValue){
      this.timer.steps =Math.ceil((newValue.length - 1)/this.periodo_dias_frame) +1
      //this.timer._current_step = Math.ceil((this.dias.length-1)/this.periodo_dias_frame)
    },
    valor_actual: function(newValue){
      if(!this.reproductor_is_play){
        //console.log("se asgina un step a timer porque no es play")
        this.timer._current_step = Math.ceil(newValue/this.periodo_dias_frame)
      }
      
      //console.log("se asigno el step",this.timer._current_step)
    },
    reproductor_is_play: function (newValue){
      if(newValue){
        this.timer.play()
      }else{
        //console.log("Se pausoooo")
        this.timer.pause()
      }
    }
  },
  methods:{
    cambioSlider: function(event){
      //console.log(event.target.value)
    },
    toggle_play: function(){
      if(this.timer._current_step=== this.timer.steps-1 && !this.reproductor_is_play){
        this.valor_actual = 0
      }
      setTimeout(()=>{
        this.reproductor_is_play = !this.reproductor_is_play
      },20)
      //

    }
  },
  destroyed:function(){
    this.timer.pause()
  }
}

const generateDateFormat=(dateString)=>{
  const date = new Date(dateString+"T00:00:00.000Z");  // 2009-11-10
  const month = date.toLocaleDateString('es', { month: 'long' ,timeZone:'UTC'});

//console.log(month);
return `${date.getUTCDate()}-${month}-${date.getUTCFullYear() }`
}

</script>

<style lang="scss">
$padding: $gap * .5;

.contenedor-reproductor {
  padding: $padding;
  .nota {
    margin: 5px 0 -5px;
    font-size: map-get($fuente, "size-notas");
  }
}
.reproductor {
  display: flex;
  .controles {
    padding: 0 $gap*.5 0 0;
  }
  .historico {
    flex: 1;
    position: relative;
    padding: $gap*.35 0 0;
    .fecha {
      display: flex;
      justify-content: space-between;
      padding: 5px 0 0 5px;
      font-size: 10px;
    }
  }
}

.btn.play {
  min-width: 40px;
  min-height: 40px;
  background-color: #fff;
  box-shadow: 1px 1px 5px 2px lightgray;
  margin: 0;
}

.tooltip-reproductor {
  background: white;
  color: black;
  padding: 4px ;
  position: absolute;
  border-radius: 4px;
  white-space: nowrap;
  //left: 50%;
  top: 5px;
  transform: translateX(-50%) translateY(-100%);
  min-width: 120px;
  box-shadow: 0 2px 4px rgba(0,0,0,.3);
  text-align: center;
  font-size: map-get($fuente, "size-notas");
}

.tooltip-reproductor::after {
  content: "";
  position: absolute;
  display: block;
  left: 50%;
  transform: translateX(-50%);
  border-color: #fff transparent transparent;
  border-width: 12px 10px 0 10px;
  border-style: solid solid none solid;
}
.tooltip-reproductor::before {
  content: "";
  position: absolute;
  left: calc(50% - 1px);
  display: block;
  transform: translateX(-50%);
  border-color: rgb(197, 196, 196) transparent transparent;
  border-width: 9px 8px 0 8px;
  border-style: solid solid none solid;
  top: 25px;
}

input[type=range].slider-reproductor {
  width: 100%;
  margin: 0;
  background-color: transparent;
  -webkit-appearance: none;
  padding: 0;
  border: none;
}
input[type=range].slider-reproductor:focus {
  outline: none;
}
input[type=range].slider-reproductor::-webkit-slider-runnable-track {
  background: #4468f3;
  border: 0;
  border-radius: 2.9px;
  width: 100%;
  height: 8.4px;
  cursor: pointer;
}
input[type=range].slider-reproductor::-webkit-slider-thumb {
  margin-top: -6.8px;
  width: 22px;
  height: 22px;
  background: #ffffff;
  border: 0.1px solid #000000;
  border-radius: 11px;
  cursor: pointer;
  -webkit-appearance: none;
}
input[type=range].slider-reproductor:focus::-webkit-slider-runnable-track {
  background: #5274f4;
}
input[type=range].slider-reproductor:hover {
  border: none;
  box-shadow: none;
}
input[type=range].slider-reproductor::-moz-range-progress {
  background-color: #4468f3;
  height: 8.4px;
}
input[type=range].slider-reproductor::-moz-range-track {
  background: lightgray;
  border: 0;
  border-radius: 2.9px;
  width: 100%;
  height: 8.4px;
  cursor: pointer;
}
input[type=range].slider-reproductor::-moz-range-thumb {
  width: 22px;
  height: 22px;
  background: #ffffff;
  border: 0.1px solid #000000;
  border-radius: 11px;
  cursor: pointer;
}
input[type=range].slider-reproductor::-ms-track {
  background: transparent;
  border-color: transparent;
  border-width: 7.8px 0;
  color: transparent;
  width: 100%;
  height: 8.4px;
  cursor: pointer;
}
input[type=range].slider-reproductor::-ms-fill-lower {
  background: #365cf2;
  border: 0;
  border-radius: 5.8px;
}
input[type=range].slider-reproductor::-ms-fill-upper {
  background: #4468f3;
  border: 0;
  border-radius: 5.8px;
}
input[type=range].slider-reproductor::-ms-thumb {
  width: 22px;
  height: 22px;
  background: #ffffff;
  border: 0.1px solid #000000;
  border-radius: 11px;
  cursor: pointer;
  margin-top: 0px;
}
input[type=range].slider-reproductor:focus::-ms-fill-lower {
  background: #4468f3;
}
input[type=range].slider-reproductor:focus::-ms-fill-upper {
  background: #5274f4;
}
/*TODO: Use one of the selectors from https://stackoverflow.com/a/20541859/7077589 and figure out
how to remove the virtical space around the range input in IE*/
@supports (-ms-ime-align:auto) {
  /* Pre-Chromium Edge only styles, selector taken from hhttps://stackoverflow.com/a/32202953/7077589 */
  input[type=range].slider-reproductor {
    margin: 0;
    /*Edge starts the margin from the thumb, not the track as other browsers do*/
  }
}
</style>
